import { useEffect, useState } from "react";
import { useData } from "../../../hooks";
import { useNavigate } from "react-router-dom"; // 추가

function SignOut() {
  const navigate = useNavigate(); // 추가
  const { logoutUser } = useData();
  
  useEffect(() => {
    logoutUser();
    navigate("/authentication/sign-in");
  }, []);


  
}

export default SignOut;
